import api from "../../../../services/api";

export const getSelectOptions = async (route: string) => {
    return (await api.get(route)).data;
}